import React, { useEffect, useState } from 'react'
import './ContactUs.css'
import { submitEnquiry } from '../lib/enquiries'
import Footer from '../Components/Footer'
import Navbar from './Components/Navbar'

function ContactUs() {
  const [form, setForm] = useState({ firstName: '', lastName: '', phone: '', email: '', message: '' });
  const [status, setStatus] = useState(null); // { ok, text }
  const [sending, setSending] = useState(false);

  useEffect(()=>{
    window.scrollTo(0,0)
  }, [])

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (!form.email.trim() || !form.message.trim()) {
      setStatus({ ok: false, text: 'Please add your email and a short message.' });
      return;
    }

    setSending(true);
    const res = await submitEnquiry({
      type: 'contact',
      name: `${form.firstName} ${form.lastName}`.trim(),
      email: form.email,
      phone: form.phone,
      message: form.message,
    });
    setStatus({ ok: res.success, text: res.message });
    if (res.success) setForm({ firstName: '', lastName: '', phone: '', email: '', message: '' });
    setSending(false);
  };
  
  return (
    <>
    <Navbar/>
    <div className='contactUsMainContainer'>
      <div className='contactUsContentContainer'>
        <div className='contactUsFormContainer'>
            <p className='contactUsHeading'>CONTACT US</p>
            <form className='inputFormContainer' onSubmit={handleSubmit}>
                <div className='inputContainer1'>
                    <input placeholder='First Name' value={form.firstName} onChange={set('firstName')} disabled={sending} />
                    <input placeholder='Last Name' value={form.lastName} onChange={set('lastName')} disabled={sending} />
                </div>
                <div className='inputContainer1'>
                    <input placeholder='Phone Number' type='tel' value={form.phone} onChange={set('phone')} disabled={sending} />
                    <input placeholder='Email *' type='email' required value={form.email} onChange={set('email')} disabled={sending} />
                </div>
                <div className='inputContainer2'>
                    <textarea placeholder='Tell us what you need *' required value={form.message} onChange={set('message')} disabled={sending}></textarea>
                </div>
                {status && (
                  <p className={status.ok ? 'formStatus formStatus--ok' : 'formStatus formStatus--error'}>{status.text}</p>
                )}
                <div className='buttonContainer'>
                    <button type='submit' disabled={sending}>{sending ? 'SENDING…' : 'SEND'}</button>
                </div>
            </form>
        </div>
        <div className='contactUsImageContainer'>
            <img src='./about1.jpeg'></img>
        </div>
      </div>
      
      {/* Contact Details Section */}
      <div className='contactDetailsContainer'>
        <h2 className='contactDetailsHeading'>OUR DETAILS</h2>
        <div className='contactDetailsInfo'>
          <div className='contactDetail'>
            <h3>Address</h3>
            <p>123 Sample Street, Glasgow, Scotland</p>
          </div>
          
          <div className='contactDetail'>
            <h3>Email</h3>
            <a href="mailto:info@elaichilove.com">info@elaichilove.com</a>
          </div>
          
          <div className='contactDetail'>
            <h3>Phone</h3>
            <a href="tel:+447731704144">+44 7731 704144</a>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default ContactUs
